/*eslint-disable */
export default{
    methods:{
        checkFileExtension(file){
            var extension = file.substr( (file.lastIndexOf('.') +1) );
            if(extension.lastIndexOf("?") == 3){
             extension = extension.substring(0, extension.lastIndexOf("?"));
            }
              switch(extension) {
                  case 'jpg':
                    return require('@/assets/images/filetype/jpg.png')
                    break;
                  case 'jpeg':
                    return require('@/assets/images/filetype/jpg.png')
                    break;
                  case 'png':
                    return require('@/assets/images/filetype/png.png')
                    break;
                  case 'gif':
                    return require('@/assets/images/filetype/jpg.png')
                    break;
                  case 'zip':
                    return require('@/assets/images/filetype/zip.png')
                    break;
                  case 'rar':
                    return require('@/assets/images/filetype/zip-1.png');
                    break;
                  break;
                  case 'eps':
                    return require('@/assets/images/filetype/ai.png')
                    break;
                  case 'pdf':
                    return require('@/assets/images/filetype/pdf.png')
                    break;
                  case 'css':
                    return require('@/assets/images/filetype/css.png')
                    break;
                  case 'csv':
                    return require('@/assets/images/filetype/csv.png')
                    break;
                  case 'doc':
                    return require('@/assets/images/filetype/doc.png')
                    break;
                  case 'docx':
                    return require('@/assets/images/filetype/doc.png')
                    break;
                  case 'json':
                    return require('@/assets/images/filetype/json-file.png')
                    break;
                  case 'ppt':
                    return require('@/assets/images/filetype/ppt.png')
                    break;
                  case 'pptx':
                    return require('@/assets/images/filetype/ppt.png')
                    break;
                  case 'txt':
                    return require('@/assets/images/filetype/txt.png')
                    break;
                  case 'xls':
                    return require('@/assets/images/filetype/xls.png')
                    break;
                  case 'xml':
                    return require('@/assets/images/filetype/xml.png')
                    break;
                  default:
                    return require('@/assets/images/filetype/search.png')
              } 
        }
    }
}